<!-- DivUpload：2019-12-18 Vue: ^2.5.2 YuAng-->

<template>
  <ya-dialog-box class="class-space-dialog" :visible.sync="visible" width="700px" :class="file.sType" :fast-close="false" :father-action="dialogAction" multi-layer>
    <p slot="title">上传</p>
    <div class="bk-form-item">
      <span class="form-item-label" style="top: 6px;width:52px;">
        <i style="color: #FE0000">* </i>
        文件：
      </span>
      <div class="form-item-detail" style="width: 87% !important;margin-left:57px !important;">
        <div-upload-item v-for="(file, i) in fileList" :key="'file-' + i" :file-list="fileList" :item="file" @remove-file="removeFile" @upload-agrin="uploadAgain" @update-list="updateList"></div-upload-item>
        <div v-if="fileList.length < 10" class="bk-add-files">
          <button @click="addFiles()" class="its-base-btn its-primary-btn" :class="{'bk-margin-top': fileList.length === 0}">
            + 添加文件（{{fileList.length}}/{{fileLimit}}）
          </button>
        </div>
      </div>
    </div>
    <div class="bk-form-item">
      <span class="form-item-label">
        <i style="color: #FE0000">*</i>
        分享班级：
      </span>
      <div class="form-item-detail">
        <div class="its-class-items">
          <el-checkbox-group class="its-class-checkbox" v-model="checkList" @change="selectedClass">
            <el-checkbox class="its-class-item" :class="{'active':checkList.indexOf(item.classId)>=0}"  v-for="(item, i) in list" :key="i" :label="item.classId" :title="item.gradeName+item.className">{{item.gradeName+item.className}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="bk-form-item">
      <span class="form-item-label">
        <i style="color: #FE0000">*</i>
        存储文件：
      </span>
      <div class="form-item-detail">
        <el-tree ref="dataTree" node-key="id" class="its-tree" :data="treeData" :expand-on-click-node="true"
         :props="defaultProps" @node-click="handleNodeClick" accordion :default-expanded-keys="defaultExpandedKeys" >
          <p slot-scope="{node,data}" class="customize-tree-p">
              <span v-if="parseInt(data.id) > 0" class="its-file"></span>
              <span class="li-node-title" :class="node.isCurrent ? 'active':''" :title="data.fileName">
                {{data.fileName}}
              </span>
          </p>
        </el-tree>
      </div>
    </div>
    <button class="ts-base-btn ts-primary-btn padding" slot="btn" @click="dialogAction({type: 'close'})" style="margin-right: 10px">取消</button>
    <button class="ts-base-btn ts-primary-btn plain padding" slot="btn"  @click="dialogAction({type: 'ok'})" :disabled="disabled">确定</button>
  </ya-dialog-box>
</template>

<script>
import YaDialogBox from '@/components/YaDialogBox'
import { classSpaceApi } from '@/utils/api'
import DivUploadItem from './DivUploadItem.vue'

export default {
  name: 'DivUpload',
  components: { YaDialogBox, DivUploadItem },
  props: {
    visible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    fileList: { // 上传文件列表
      type: Array,
      default: function () {
        return []
      }
    },
    file: {
      type: Object,
      default: function () {
        return { name: '我是文件标题', path: 'xxx', percent: 0.8, statusName: 'upload' }
      }
    },
    textbookId: {
      type: Number
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    // treeData: {
    //   type: Array,
    //   default: function () {
    //     return []
    //   }
    // },
    defaultCheckedKeys: {
      default: 0
    },
    defaultProps: {
      type: Object,
      default: function () {
        return {
          label: 'fileName',
          children: 'childFolder',
          isLeaf: 'isLeaf'
        }
      }
    },
    fileLimit: { // 当前允许上传的文件个数限制
      type: Number,
      default: 10
    },
    uploadLimit: {// 允许上传的文件总个数
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      defaultExpandedKeys: [0],
      dataTreeVisible: true,
      options: [],
      checkList:[],
      form: {
        filePath: '',
        fileName: '',
        size: 0,
        catalog: { id: 3 },
        nodePath: []
      },
      currentNodeId: 'leaf',
      chapter: { node: { name: '请选择', active: false }, parent: {} },
      showChapter: false,
      nodes: [],
      treeData: [
        {
          id: 0,
          fileName: '全部文件',
          childFolder: [],
          filePath: '0'
        }
      ],
      selectedNode: {},
      filesError: false
    }
  },
  computed: {
    status: function () {
      // 文件上传进度状态监听
      return this.file.statusName === 'progress' ? '—' : (this.file.statusName !== 'error' ? 'success' : 'exception')
    },
    disabled: function () {
      const files = this.fileList.filter(file => { return file.status !== 'error' })
      if (files.length === 0) {
        return true
      }
      const completeUpload = files.filter(file => { return file.percent === 100 })
      const result = (completeUpload.length !== files.length) || this.filesError || this.checkList.length === 0 || !this.selectedNode.filePath || this.fileList.length === 0
      return result
    }
  },
  mounted () {
    // this.form.filePath = this.file.relativePath
    // this.form.size = this.file.size
    // this.form.fileName = this.file.name.substring(0, this.file.name.lastIndexOf('.'))
    this.getTreeDatas()
  },
  methods: {
    removeFile: function (item) {
      // 删除文件
      this.$emit('remove-file', item)
    },
    uploadAgain: function (item) {
      // 重新上传
      this.$emit('add-files')
      this.removeFile(item)
    },
    addFiles: function () {
      if (this.fileList.length < this.uploadLimit) {
        this.$emit('add-files', this.form.filePath)
      }
    },
    dialogAction: function (action) {
      let methodName = 'uploadAction'
      this[methodName](action)
    },
    uploadAction: function (action) {
      if (action.type === 'close') {
        this.$set(this.file, 'statusName', 'cancel')
        this.form = {}
        this.$emit('clear-file-list')
        this.$emit('upload-complete-action', { type: 'cancel' })
      } else if (action.type === 'ok') {
        // if (this.file.statusName === 'progress') {
        //   this.$message.error('请等待文件上传完毕，再提交')
        //   return
        // }
        console.log('表单数据：', this.form)
        this.$store.state.loading = true
        this.clicked = true
        let files = this.fileList.filter(file => { return file.status !== 'error' })
        // debugger
        let result = []
        this.list.forEach((item)=>{
          if(this.checkList.indexOf(item.classId)>=0){
            result.push(item)
          }
        })
        // this.file.shareClazzList = result
        const uploadFiles = []
        files.forEach(file => {
          // let params = { name: file.fileName, size: file.size, extension: file.extension, relativePath: file.relativePath }
          let params = { 
            fileName: file.fileName,
            size: file.size,
            extension: file.extension,
            relativePath: file.relativePath,
            classSpaceId: this.selectedNode.id,
            path: this.selectedNode.filePath + '/' + this.selectedNode.id,
            shareClazzList: result
         }
          uploadFiles.push(params)
        })
        // this.form.uploadFiles = uploadFiles
        // this.$emit('clear-file-list')
        // this.$emit('upload-complete-action', { type: 'ok', chapter: this.chapter })

        // this.file.fileName = this.form.fileName
        // this.file.classSpaceId = this.selectedNode.id
        // this.file.path = this.selectedNode.filePath + '/' + this.selectedNode.id
        
        this.$emit('submit', {type: 'upload-ok', upload: uploadFiles})
      }
    },
    // dialogAction: function (action) {
    //   if (action.type === 'ok') {
    //     if (!this.form.fileName.trim()) {
    //       this.$message.error('请填写标题')
    //       return
    //     }
    //     // 校验特殊字符
    //     let reg = /["*<>?:|/'\\]/im
    //     if (reg.test(this.form.fileName)) {
    //       this.$message.error('标题中含有非法字符')
    //       return
    //     }
    //     if (this.file.statusName === 'progress') {
    //       this.$message.error('请等待文件上传完毕，再提交')
    //       return
    //     }
    //   } else if (action.type === 'close') {
    //     this.$emit('update:visible', false)
    //     this.$emit('upload-complete-action', { type: 'cancel' })
    //     return
    //   }

    //   this.file.fileName = this.form.fileName
    //   this.file.classSpaceId = this.selectedNode.id
    //   this.file.path = this.selectedNode.filePath + '/' + this.selectedNode.id
    //   let result = []
    //   this.list.forEach((item)=>{
    //     if(this.checkList.indexOf(item.classId)>=0){
    //       result.push(item)
    //     }
    //   })
    //   this.file.shareClazzList = result
    //   this.$emit('submit', {type: 'upload-ok', upload: this.file})
    //   // let methodName = this.file.sType + 'Action'
    //   // this[methodName](action)
    // },
    treeAction: function (action) {
      this.form.nodePath = action.path
      this.chapterAction(action.node)
    },
    chapterAction: function (node, parent) {
      this.chapter.node.active = false
      node.active = true
      this.chapter.node = node
      this.chapter.parent = parent
      console.log('选中了', node, parent)
      // 区分是否是资源列表项，是则parent为所在叶节点 YuAng
      if (parent) {
        let pathNodes = [parent]
        this.$refs.tree.getPathNodes(pathNodes)
        this.form.nodePath = pathNodes
      }
      this.showChapter = false
    },
    selectedClass: function () {
      console.log(this.checkList)
    },
    handleNodeClick: function (data, node) {
      console.log(data, node)
      this.selectedNode = data
      // this.$emit('node-click', {type: 'nodeClick', item: this.selectedItm})
    },
    getTreeDatas: function () {
      let params = {
        subjectId: this.$store.state.subjectId
      }
      classSpaceApi.getNewFolderList(params).then((res) => {
        console.log(res)
        if (res.success) {
          let result = res.body
          if (!result) {
            this.$message.error('抱歉！您不能将自己任教科目以外的资源分享到班级空间！')
          } else {
            this.treeData[0].childFolder = result
            this.$nextTick(() => {
              if (this.$refs.dataTree) {
                this.defaultExpandedKeys = [this.defaultCheckedKeys]
                let currentNode = this.$refs.dataTree.getNode(this.defaultCheckedKeys)
                if (currentNode) {
                  currentNode.isCurrent = true
                  this.selectedNode = currentNode.data
                }
              }
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    updateList: function () {
      const files = this.fileList.filter(file => { return file.status !== 'error' })
      if (files.length === 0) {
        return true
      }
      const completeUpload = files.filter(file => { return file.percent === 100 })
      if (completeUpload.length !== files.length) {
        return true
      }
      let emptyFileNames = this.fileList.filter(file => { return file.fileName === ''})
      let illegalName = false
      let regu = '^[ ]+$'
      let re = new RegExp(regu)
      this.fileList.forEach(file => {
        let fileIllegal = re.test(file.fileName)
        if (fileIllegal) {
          illegalName = true
        }
      })
      console.log('----files---disabled----')
      this.filesError = emptyFileNames.length > 0 || illegalName
    }
  },
  watch: {
    visible: function () {
      if (this.visible) {
        this.$emit('clear-file-list')
        this.getTreeDatas()
      } else {
        this.$emit('clear-file-list')
      }
    },
    fileList: {
      handler: function () {
        this.updateList()
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.ya-dialog-content {
  padding: 15px !important;
}

.ul-form-item {
  height: 80px;
  background: #F5F5F5;
  margin-bottom: 10px;
  padding: 8px;
  overflow: auto;
  border-radius: 4px;
}

.form-item-detail {
  width: 78% !important;
  margin-left: 85px !important;
  position: relative;
}
.bk-form-item {
  position: relative;
  margin-bottom: 20px;
}

.bk-form-item .form-item-label {
  position: absolute;
  left: 0;
  top: 3px;
  color: #333333;
  font-size: 14px;
  width: 80px;
}

.bk-form-item .form-item-detail {
  width: 78%;
  margin-left: 50px;
  min-height: 30px;
}

.bk-form-item .form-item-detail-small {
  width: calc(98% - 90px);
  margin-left: 65px;
  min-height: 30px;
}

.bk-form-item .form-item-detail .bk-chapter-kp,
.bk-form-item .form-item-detail-small .bk-chapter-kp {
  float: right;
  color: #EEBA6B;
  cursor: pointer;
  padding: 5px 0;
}

.bk-form-item .form-item-detail .empty{
  padding-top: 4px;
}

.bk-form-item .form-item-label {
  top: 5px;
}

.bk-form-item:first-child .form-item-label {
  top: 0px;
}

.bk-form-item:nth-child(2) >>> .el-input__inner {
  border: 1px solid #E6E6E6;
  border-radius: 6px;
  color: #999999;
}

.ya-dialog-box >>> .el-progress__text i {
  font-family: "iconfont" !important;
  font-size: 12px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: scale(0.8);
}

.ya-dialog-box >>> .el-icon-circle-check {
  color: #0091FA;
}

.ya-dialog-box >>> .el-icon-circle-check {
  display: none;
}

.ya-dialog-box >>> .el-icon-circle-close:before {
  content: "\e8b5";
}

.ya-dialog-box >>> .el-progress.is-success .el-progress-bar__inner {
  background-color: #0091FA;
}

.ya-dialog-box >>> .el-progress-bar__outer {
  background-color: #EEF1F7;
}

.its-class-checkbox .its-class-item {
  margin-bottom: 10px;
  margin-right: 15px !important;
}

.its-class-items {
  padding-top: 5px;
}

.its-class-checkbox .its-class-item.active{
  /* background: #5591fe; */
  color: #5591FE;
  border-radius: 4px;
}

.its-class-checkbox .its-class-item>>>.el-checkbox__label{
  padding-left: 8px;
  color: #262626;
  font-size: 14px;
  line-height: 1;
  width: 233px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: sub;
}

.its-class-checkbox .its-class-item.active>>>.el-checkbox__label{
  color: #5591FE;
}

.its-class-checkbox .its-class-item.active:hover{
  opacity: 0.8;
}

.li-node-icon {
  width: 17px;
  height: 17px;
}

.its-file {
  background-image: url(../../../../assets/images/file.png);
  background-size: 100%;
  background-repeat: no-repeat;
  width: 17px;
  height: 14px;
  display: inline-block;
  vertical-align: text-top;
}

.li-node-title {
  color: #262626;
  font-size: 14px;
  margin-left: 2px;
}

.li-node-title.active {
  color: #2695FF;
}

.its-success {
  position: absolute;
  right: 22px;
  bottom: 0px;
  color: #0091FA;
  font-size: 12px;
}

.bk-add-files {

}

.its-base-btn {
  border: none;
  color: #2695FF;
  font-size: 14px;
  background-color: transparent !important;
  margin-left: -13px;
  height: 18px;
  margin-top: -10px;
}

.bk-margin-top {
  margin-top: 6px;
}

.class-space-dialog >>> .ya-dialog-content {
  padding: 15px 17px;
}

.class-space-dialog >>> .el-dialog__header {
  border-bottom: 1px solid #F7F7F7;
}
</style>
